import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TaskStatus, WorkflowService, TaskTransition } from '@alfresco/aca-shared';
import { SnackbarErrorAction, SnackbarInfoAction } from '@alfresco/aca-shared/store';

import { MatButtonModule } from '@angular/material/button';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';

@Component({
  standalone: true,
  imports: [CommonModule, TranslateModule, MatDialogModule, MatButtonModule],
  selector: 'adf-my-tasks-dialog',
  templateUrl: './my-tasks.dialog.html',
  styleUrls: ['./my-tasks.dialog.scss'],
  host: { class: 'adf-my-tasks-dialog' },
  encapsulation: ViewEncapsulation.None
})
export class MyTasksDialogComponent implements OnInit {

  actionStarted: boolean = false;
  greenTasks: any[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { tasks: any[] },
    private dialogRef: MatDialogRef<MyTasksDialogComponent>,
    private workflowService: WorkflowService,
    private store: Store,
    private translation: TranslateService
  ) {
    const allowedTaskNames = [
      'ncwf:completedMultipleAdhocTask',
      'ncwf:multipleLevelApprovedTask',
      'ncwf:endGroupAdhocTask',
      'wf:approvedParallelTask'
    ];

    this.greenTasks = data.tasks.filter(task =>
      allowedTaskNames.includes(task.name)
    );
  }

  ngOnInit() {}

  async onYesClick(): Promise<void> {
    if (this.actionStarted) return;
    this.actionStarted = true;

    if (!this.greenTasks.length) {
      this.store.dispatch(new SnackbarInfoAction(this.translation.instant('APP.WORKFLOW.GENERAL.TASK_COMPLETE.YES')));
      this.dialogRef.close('refresh');
      this.actionStarted = false;
      return;
    }

    let hasErrors = false;

    for (const task of this.greenTasks) {
      try {
        await this.workflowService.editTask(
          task.id,
          [],
          [],
          '',
          TaskStatus.COMPLETED,
          TaskTransition.TASK_DONE
        );
      } catch (error) {
        console.error('Error completing task:', task.id, error);
        hasErrors = true;
      }
    }

    if (hasErrors) {
      this.store.dispatch(new SnackbarErrorAction(this.translation.instant('APP.WORKFLOW.GENERAL.TASK_COMPLETE.NO')));
    } else {
      this.store.dispatch(new SnackbarInfoAction(this.translation.instant('APP.WORKFLOW.GENERAL.TASK_COMPLETE.YES')));
    }

    this.dialogRef.close('refresh');
    this.actionStarted = false;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}